import { appNotification } from './appNotification';
import api from './apiClient';
import { logoutSession, useSessionStore } from '../stores/sessionStore';
import { notificationDuration } from '../siteConfigs/generalconfig';
import { shouldClearSessionOnAuthError } from './authPublicEndpoints';

export { vpmServerUrl } from './apiClient';

api.interceptors.request.use(req => req);

api.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;
    const config = error?.config;

    if (shouldClearSessionOnAuthError(status, config)) {
      const hadUser = useSessionStore.getState().user != null;
      if (hadUser) {
        appNotification.error({
          title: 'Error',
          description: 'Session is expired. Please login again',
          duration: notificationDuration,
        });
      }
      logoutSession();
    }
    throw error;
  },
);

export default api;
